import Link from 'components/base/Link'
import Container from 'components/landing/Container'
import { c, FC } from 'lib/component-utils'

const links = [
  { href: '/', label: 'Аналитика маркетплейсов' },
  { href: '/wildberries/', label: 'Аналитика Wildberries', mall: 'wb' },
  { href: '/ozon/', label: 'Аналитика Ozon', mall: 'ozon' },
  { href: '/yandex-market/', label: 'Аналитика Яндекс Маркета', mall: 'beru' },
] as const

const MarketplaceLinks: FC<{ activeMall?: 'wb' | 'ozon' | 'beru' }> = ({ activeMall }) => {
  return (
    <Container className="!py-20">
      <section aria-labelledby="marketplace-links-title">
        <h2 id="marketplace-links-title" className="text-3xl font-medium text-left">
          Решения для маркетплейсов
        </h2>
        <nav aria-label="Страницы аналитики маркетплейсов" className="mt-8">
          <ul className="flex flex-wrap gap-3">
            {links.map(({ href, label, ...link }) => {
              const isActive = 'mall' in link ? link.mall === activeMall : !activeMall

              return (
                <li key={href}>
                  <Link
                    href={href}
                    aria-current={isActive ? 'page' : undefined}
                    className={c`inline-flex items-center rounded-full border px-6 py-3 text-base font-medium transition-colors
                      ${isActive} border-primary-600 bg-primary-600 text-white pointer-events-none | border-primary-200 bg-white text-gray-900 hover:bg-primary-100
                    `}
                  >
                    {label}
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>
      </section>
    </Container>
  )
}

export default MarketplaceLinks
